export default __webpack_public_path__ + "static/glyphicons-halflings.dea5a7be07359b7090a3fa90b1ff0cef.png";